// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedOculign_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8.34332 2.90525L3.6374 2.59961L4.34846 3.92018C0.887791 5.78312 -0.80364 9.44199 0.376747 12.3039L2.15792 11.345C1.64463 9.69869 2.51289 7.17944 5.29654 5.68095L6.0076 7.00153L8.34332 2.90525Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0112 12.0005C15.0112 13.6574 13.6687 15.0005 12.0126 15.0005C10.3566 15.0005 9.01405 13.6574 9.01405 12.0005C9.01405 10.3437 10.3566 9.00054 12.0126 9.00054C13.6687 9.00054 15.0112 10.3437 15.0112 12.0005ZM13.0122 12.0005C13.0122 12.5528 12.5647 13.0005 12.0126 13.0005C11.4606 13.0005 11.0131 12.5528 11.0131 12.0005C11.0131 11.4483 11.4606 11.0005 12.0126 11.0005C12.5647 11.0005 13.0122 11.4483 13.0122 12.0005Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0126 6.00054C8.28663 6.00054 4.90406 8.55009 4.01639 12.0005C4.90406 15.451 8.28663 18.0005 12.0126 18.0005C15.7385 18.0005 19.1212 15.451 20.0089 12.0005C19.1212 8.55009 15.7385 6.00054 12.0126 6.00054ZM18.0098 12.0005C17.1866 9.67016 14.6238 8.00054 12.0126 8.00054C9.40135 8.00054 6.83875 9.67016 6.01546 12.0005C6.83875 14.3309 9.40135 16.0005 12.0126 16.0005C14.6238 16.0005 17.1866 14.3309 18.0098 12.0005Z" class="svg-bg"/>
  <path d="M20.3677 21.4031L15.6628 21.098L17.9985 17.0006L18.7093 18.3213C21.4926 16.8222 22.361 14.3023 21.848 12.6557L23.6201 11.6964C24.7999 14.5587 23.1171 18.2186 19.6569 20.0823L20.3677 21.4031Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedOculign is a generated icon component.
 */
let IconMedOculign = IconMedOculign_1 = class IconMedOculign extends IconBaseElement {
    render() {
        return html `${IconMedOculign_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedOculign.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedOculign = IconMedOculign_1 = __decorate([
    customElement('zui-icon-med-oculign')
], IconMedOculign);
export { IconMedOculign };
